<template>
  <svg fill="currentColor" viewBox="0 0 20 20">
    <path
      d="M16.707 5.293a1 1 0 00-1.414 0L8 12.586 4.707 9.293a1 1 0 00-1.414 1.414l4 4a1 1 0 001.414 0l8-8a1 1 0 000-1.414z" />
  </svg>
</template>
